(() => {
  if (customElements.get('withdrawal-form')) return;
  class WithdrawalForm extends HTMLElement {
    static stamp(date) {
      const parts = new Intl.DateTimeFormat('de-DE', {
        timeZone: 'Europe/Zagreb', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
      }).formatToParts(date).reduce((all, p) => ({ ...all, [p.type]: p.value }), {});
      return `${parts.day}.${parts.month}.${parts.year}, ${parts.hour}:${parts.minute} (Zagreb)`;
    }
    connectedCallback() {
      const receipt = this.querySelector('[data-withdrawal-receipt]');
      if (receipt) {
        this.showReceipt(receipt);
        return;
      }
      const form = this.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', () => {
        const value = (name) => (form.querySelector(`[name="${name}"]`) || {}).value || '';
        const time = WithdrawalForm.stamp(new Date());
        const field = form.querySelector('[data-withdrawal-time]');
        if (field) field.value = time;
        const sent = { time, order: value('contact[Order]'), items: value('contact[Items]'), statement: value('contact[Statement]') };
        try { sessionStorage.setItem('df-withdrawal', JSON.stringify(sent)); } catch (e) { /* storage off: the e-mail still confirms */ }
      });
    }
    showReceipt(receipt) {
      let sent = null;
      try { sent = JSON.parse(sessionStorage.getItem('df-withdrawal') || 'null'); } catch (e) { sent = null; }
      if (!sent || !sent.time) return;
      const fill = (key, text) => {
        const slot = receipt.querySelector(`[data-receipt="${key}"]`);
        if (slot) slot.textContent = text;
      };
      fill('time', sent.time);
      fill('order', sent.order);
      fill('statement', sent.statement);
      fill('items', sent.items || receipt.dataset.allItems || '');
      receipt.hidden = false;
      try { sessionStorage.removeItem('df-withdrawal'); } catch (e) { /* nothing to clean */ }
    }
  }
  customElements.define('withdrawal-form', WithdrawalForm);
})();
